export default __webpack_public_path__ + "static/media/05_o_3.a9700c13.jpg";